import {FormGroup} from '@angular/forms';
import {Component, Input, OnInit} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {Card} from '../../domain/card';

@Component({
  selector: `crds-consent-form`,
  template: `
    <div class="pb-5">
      <div class="card-wrapper">
        <div class="card">
          <div class="card-body">
            <div class="card-text primary-description-lg" [innerHTML]="description"></div>
          </div>
        </div>
      </div>
      <div class="card-wrapper">
        <div class="card card-light">
          <div class="card-body">
            <div class="card-text" [innerHTML]="description2"></div>
          </div>
        </div>
      </div>
      <div class="inline-form-wrapper">
        <form [formGroup]="form.get(formKey)">
          <crds-questions [form]="form.get(formKey)" [card]="card"></crds-questions>
        </form>
      </div>
      <div class="card-wrapper">
        <div class="card card-light">
          <div class="card-body">
            <div class="card-text" [innerHTML]="description3"></div>
          </div>
        </div>
      </div>
    </div>
  `
})
export class ConsentFormComponent implements OnInit {
  @Input() card: Card<null>;
  @Input() form: FormGroup;
  @Input() formKey: string;
  description: SafeHtml;
  description2: SafeHtml;
  description3: SafeHtml;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit() {
    this.description = this.getCardDescription('description');
    this.description2 = this.getCardDescription('description2');
    this.description3 = this.getCardDescription('description3');
  }

  getCardDescription(descriptionText) {
    const match = this.card[descriptionText].match(/\{(.+)\}/);
    if (!match) {
      return this.sanitizer.bypassSecurityTrustHtml(this.card[descriptionText]);
    }
    const formRouteParts = match[1].split('.');
    let formControl = this.form.get(formRouteParts[0]);

    if (formControl && formRouteParts.length === 2) {
      formControl = formControl.get(formRouteParts[1]);
    }

    const formValue = formControl && formControl.value ? formControl.value : '';
    const description = this.card[descriptionText].replace(/\{.+\}/, formValue);
    return this.sanitizer.bypassSecurityTrustHtml(description);
  }
}
